// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ZDO-","footer":"Form_footer__2W73g"};